/**
 * Ubicaciones dentro de las zonas (racks, niveles y posiciones).
 * Oculta para clientes reales hasta que JC la libere: solo empresas is_dev
 * (EMPRESA TEST). Evaluar siempre con `impersonated ?? company`.
 * Para liberarla, cambiar esta función.
 */
export function ubicacionesHabilitadas(company?: { is_dev?: boolean | null } | null): boolean {
  // Liberada a clientes el 14/10/2026
  return true;
}
